import { GitHubCalendar } from "react-github-calendar";

export default function GitHubContributions() {
  const githubUsername = "Sashankps";

  return (
    <section id="contributions" className="min-h-[70vh] flex items-center py-24 border-t border-white/5 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col items-center w-full">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-14 text-center">
          GitHub <span className="text-[#f15700]">Contributions</span>
        </h2>
        <div className="p-6 md:p-10 rounded-3xl bg-white/[0.03] border border-white/10 w-full overflow-x-auto flex justify-center shadow-xl">
          <GitHubCalendar
            username={githubUsername}
            colorScheme="dark"
            fontSize={16}
            blockSize={16}
            blockMargin={5}
            labels={{
              totalCount: "{{count}} contributions in the last year",
            }}
            style={{
              color: "#9ca3af",
            }}
          />
        </div>
      </div>
    </section>
  );
}
